import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'axios';
import moment from 'moment';
import { useState, useEffect } from 'react';

var inputFormat = 'M/D/YYYY';
var outputFormat = 'MM/DD/YYYY';
var calendarHeaderFormat = 'MMMM YYYY';
var useStrictParse = true;
var todayMoment = moment();
todayMoment.format(outputFormat);
function unsafeInitMoment(date) {
  return moment(date, inputFormat, useStrictParse);
}
function initMoment(date) {
  var momentObj = date ? unsafeInitMoment(date) : moment();
  return momentObj.isValid() ? momentObj : moment();
}
function checkFutureDate(date) {
  return date && initMoment(date).isAfter(todayMoment, 'day');
}
function checkPastDate(date, before) {
  var pastDate = before ? initMoment(before) : todayMoment;
  return date && initMoment(date).isBefore(pastDate, 'day');
}
function checkWeekdayDate(date) {
  return date && initMoment(date).day() % 6 != 0;
}
function checkWeekendDate(date) {
  return date && initMoment(date).day() % 6 == 0;
}
function capitalizeFirstLetter(string) {
  string = string.toLowerCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function dateFormat(date) {
  return date ? initMoment(date).format(outputFormat) : '';
}
function headerFormat(activeMonth) {
  if (activeMonth) {
    initMoment(activeMonth).format('M');
    return initMoment(activeMonth).format(calendarHeaderFormat);
  } else {
    return '';
  }
}
function displayFormat(dateInfo, date, type) {
  if (type === 'week') {
    var mon = dateInfo.month_name.slice(0, 3);
    var rtlWk = capitalizeFirstLetter(mon) + ' Wk' + dateInfo.week_number_of_fiscal_month;
    return rtlWk + ', ' + dateInfo.calendar_year;
  } else {
    var month = moment(date).format('MMM');
    var displayDay = dateInfo.day_name.substr(0, 3);
    return capitalizeFirstLetter(month) + ' ' + initMoment(date).date() + ', ' + dateInfo.calendar_year + ' (' + capitalizeFirstLetter(displayDay) + ')';
  }
}
var getData = function getData() {
  // get data from local storage
  var data = JSON.parse(localStorage.getItem('canvas_calendar_data'));
  // if it has no createdTime, remove it because it is SUPER old, byeeeeee
  if (!data || !data.createdTime) {
    localStorage.removeItem('canvas_calendar_data');
    return [];
  }
  // if there are values in local storage and there is a createdTime
  if (data.value && data.createdTime) {
    // check the createdTime and if it was created in the last 24 hours, use it
    var dayInSeconds = 1000 * 60 * 60 * 24;
    var dayAgo = Date.now() - dayInSeconds;
    if (data.createdTime > dayAgo) {
      return data.value;
    } else {
      // if it's over 24 hours old, delete it, byeeeee
      localStorage.removeItem('canvas_calendar_data');
    }
  }
  // catchall to return an empty array so that we re-fetch data from the API
  return [];
};
function toActiveMonth(dateIn, type) {
  var momentObj = initMoment(dateIn);
  switch (type) {
    case 'prev':
      momentObj.subtract(1, 'month');
      break;
    case 'next':
      momentObj.add(1, 'month');
      break;
    case 'retail':
      var data = getData();
      // format it to YYYYMMDD
      dateIn = dateIn.split('/');
      var _formatDate = "".concat(dateIn[2]).concat(dateIn[0]).concat(dateIn[1]);
      // find it in our date data
      var dateObj = [];
      dateObj = data.filter(function (obj) {
        return obj.calendar_date === _formatDate;
      });
      if (dateObj.length > 0) {
        // if our fiscal data month name does not match moment's month name
        // it means that there are dates from another gregorian month included in this month
        if (dateObj[0].month_name !== momentObj.format('MMMM').toUpperCase()) {
          // then use our fiscal data month and year since we are in the retail calendar
          var correctedMonthNumber = moment().month(dateObj[0].month_name).format('MM');
          dateIn = "".concat(correctedMonthNumber, "/01/").concat(dateObj[0].fiscal_year);
          momentObj = initMoment(dateIn);
        }
      }
      break;
  }
  return dateFormat(momentObj.startOf('month'));
}
function toWeekObj(retailDate, disableDates) {
  var date = moment(retailDate.calendar_date).format('MM/DD/YYYY');
  return {
    before: checkPastDate(date, disableDates === null || disableDates === void 0 ? void 0 : disableDates.before),
    dateObj: {
      format: displayFormat(retailDate, date, 'week'),
      type: 'week',
      value: dateFormat(date),
      week: {
        endDate: moment(retailDate.end_date_of_fiscal_week).format('MM/DD/YYYY'),
        startDate: moment(retailDate.begin_date_of_fiscal_week).format('MM/DD/YYYY'),
        weekNo: retailDate ? retailDate.week_number_of_fiscal_year : ''
      }
    },
    future: checkFutureDate(date),
    past: checkPastDate(date),
    type: 'week',
    weekName: retailDate ? capitalizeFirstLetter(retailDate.month_name.substring(0, 3)) + ' Wk ' + retailDate.week_number_of_fiscal_month : '',
    weekNo: retailDate ? retailDate.week_number_of_fiscal_year : '',
    weekday: checkWeekdayDate(date),
    weekend: checkWeekendDate(date)
  };
}
function toDateObj(retailDate, disableDates) {
  var date = moment(retailDate.calendar_date).format('MM/DD/YYYY');
  return {
    before: checkPastDate(date, disableDates === null || disableDates === void 0 ? void 0 : disableDates.before),
    dateNumber: moment(retailDate.calendar_date).date(),
    dateObj: {
      format: displayFormat(retailDate, date, 'day'),
      type: 'day',
      value: dateFormat(date),
      week: {
        endDate: moment(retailDate.end_date_of_fiscal_week).format('MM/DD/YYYY'),
        startDate: moment(retailDate.begin_date_of_fiscal_week).format('MM/DD/YYYY'),
        weekNo: retailDate ? retailDate.week_number_of_fiscal_year : ''
      }
    },
    future: checkFutureDate(date),
    past: checkPastDate(date),
    type: 'day',
    weekday: checkWeekdayDate(date),
    weekend: checkWeekendDate(date)
  };
}
function chunk(arr, size) {
  return Array.from({
    length: Math.ceil(arr.length / size)
  }, function (v, i) {
    return arr.slice(i * size, i * size + size);
  });
}
function toMonthArray(activeMonthArr, disableDates) {
  var arr = [];
  for (var i = 0; i <= activeMonthArr.length - 1; i++) {
    if (i % 7 === 0) {
      arr.push(toWeekObj(activeMonthArr[i], disableDates));
    }
    arr.push(toDateObj(activeMonthArr[i], disableDates));
  }
  return [{
    monthArr: chunk(arr, 8)
  }];
}

//Modified from https://usehooks.com/useKeyPress/
function useKeyPress(targetKey) {
  // State for keeping track of whether key is pressed
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyPressed = _useState2[0],
    setKeyPressed = _useState2[1];

  // Add event listeners
  useEffect(function () {
    // If pressed key is our target key then set to true
    function downHandler(_ref) {
      var keyCode = _ref.keyCode;
      if (keyCode === targetKey) {
        setKeyPressed(true);
      }
    }

    // If released key is our target key then set to false
    function upHandler(_ref2) {
      var keyCode = _ref2.keyCode;
      if (keyCode === targetKey) {
        setKeyPressed(false);
      }
    }
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return function () {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey]);
  return keyPressed;
}
function checkValidDateFormat(str) {
  if (!str) return true;
  var regExp = /^\d{1,2}[/]\d{1,2}[/]\d{4}$/;
  return str && regExp.test(str) && unsafeInitMoment(str).isValid();
}
function checkSameDate(date1, date2) {
  return date1 && date2 && checkValidDateFormat(date1) && checkValidDateFormat(date2) ? initMoment(date1).isSame(initMoment(date2), 'day') : false;
}
function checkBetweenFiscalWeek(fiscalWeek, date1) {
  return date1 && fiscalWeek !== null && fiscalWeek !== void 0 && fiscalWeek.startDate && fiscalWeek !== null && fiscalWeek !== void 0 && fiscalWeek.endDate && checkValidDateFormat(date1) && checkValidDateFormat(fiscalWeek.startDate) && checkValidDateFormat(fiscalWeek.endDate) ? initMoment(date1).isSameOrAfter(initMoment(fiscalWeek.startDate), 'day') && initMoment(date1).isSameOrBefore(initMoment(fiscalWeek.endDate), 'day') : false;
}
function checkFiscalWeekEndsInFuture(date) {
  var _date$dateObj, _date$dateObj$week, _date$dateObj2, _date$dateObj2$week;
  return date !== null && date !== void 0 && (_date$dateObj = date.dateObj) !== null && _date$dateObj !== void 0 && (_date$dateObj$week = _date$dateObj.week) !== null && _date$dateObj$week !== void 0 && _date$dateObj$week.endDate ? checkFutureDate(date === null || date === void 0 ? void 0 : (_date$dateObj2 = date.dateObj) === null || _date$dateObj2 === void 0 ? void 0 : (_date$dateObj2$week = _date$dateObj2.week) === null || _date$dateObj2$week === void 0 ? void 0 : _date$dateObj2$week.endDate) : false;
}
function checkDateInList(date, allowList) {
  for (var i = 0; i < allowList.length; i++) {
    var _date$dateObj3;
    if (checkSameDate((date === null || date === void 0 ? void 0 : (_date$dateObj3 = date.dateObj) === null || _date$dateObj3 === void 0 ? void 0 : _date$dateObj3.value) || date, allowList[i].toString())) {
      return true;
    }
  }
  return false;
}
function checkDateInListIsInFiscalWeek(date, allowList) {
  for (var i = 0; i < allowList.length; i++) {
    var _date$dateObj4;
    if (checkBetweenFiscalWeek((date === null || date === void 0 ? void 0 : (_date$dateObj4 = date.dateObj) === null || _date$dateObj4 === void 0 ? void 0 : _date$dateObj4.week) || date, allowList[i].toString())) {
      return true;
    }
  }
  return false;
}

// formats incoming external date values if they are just passed in as strings
var formatValue = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, fetchData) {
    var formattedDate, formattedWeek, formattedMonth, formattedYear, splitMonthWeekYear;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formattedDate = null;
            formattedWeek = null;
            formattedMonth = null;
            formattedYear = null; // if the string is in week notation
            if (!value.includes('Wk')) {
              _context.next = 16;
              break;
            }
            // split up month, week and year into an array
            splitMonthWeekYear = value.split(' '); // grab and format month, week and year
            formattedMonth = moment().month(splitMonthWeekYear[0]).format('MM').toUpperCase();
            formattedYear = splitMonthWeekYear[2];
            formattedWeek = splitMonthWeekYear[1].replace('Wk', '').replace(',', '');
            // format it to YYYYMMDD
            formattedDate = "".concat(formattedYear).concat(formattedMonth, "15");
            _context.next = 13;
            return fetchData(formattedDate).then(function (resp) {
              var dateObj = resp.filter(function (obj) {
                return obj.week_number_of_fiscal_month === formattedWeek;
              }).filter(function (obj) {
                return obj.day_number_for_given_week === '1';
              });
              var formattedDateObj = toWeekObj(dateObj[0]);
              return formattedDateObj.dateObj;
            });
          case 13:
            return _context.abrupt("return", _context.sent);
          case 16:
            // format it to YYYYMMDD
            value = value.split('/');
            formattedDate = "".concat(value[2]).concat(value[0]).concat(value[1]);
            _context.next = 21;
            return fetchData(formattedDate).then(function (resp) {
              var dateObj = resp.filter(function (obj) {
                return obj.calendar_date === formattedDate;
              });
              var formattedDateObj = toDateObj(dateObj[0]);
              return formattedDateObj.dateObj;
            });
          case 21:
            return _context.abrupt("return", _context.sent);
          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function formatValue(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var selectedWeekCheck = function selectedWeekCheck(isDisabled, selectedDate, dayObj) {
  if (selectedDate) {
    // take the first 6 caracters off the date value to leave only the year
    var dayYear = dayObj.dateObj.value.substr(6);
    var selectedDateYear = selectedDate.value.substr(6);
    return !isDisabled && selectedDate && selectedDate.type === 'week' && dayObj.type === 'week' && selectedDate.week.weekNo === dayObj.weekNo &&
    // if we do not check for the years to match, it will select that week number in every year
    dayYear === selectedDateYear;
  } else {
    return false;
  }
};
var selectedDayCheck = function selectedDayCheck(isDisabled, selectedDate, dayObj) {
  return !isDisabled && selectedDate && selectedDate.type !== 'week' && checkSameDate(dayObj.dateObj.value, selectedDate.value);
};
var isDayDisabledCheck = function isDayDisabledCheck(dayObj, disableDatesObj) {
  if (disableDatesObj) {
    if (disableDatesObj.past && dayObj.past || disableDatesObj.future && dayObj.future || disableDatesObj.weekdays && dayObj.weekday || disableDatesObj.weekends && dayObj.weekend || disableDatesObj.before && dayObj.before || disableDatesObj.except && !checkDateInList(dayObj, disableDatesObj.except) || disableDatesObj.only && checkDateInList(dayObj, disableDatesObj.only)) {
      return true;
    }
  }
  return false;
};
var isWeeklyDisabledCheck = function isWeeklyDisabledCheck(dayObj, disableDatesObj) {
  if (isDayDisabledCheck(dayObj, disableDatesObj)) {
    return true;
  }
  if (disableDatesObj) {
    if (disableDatesObj.future && checkFiscalWeekEndsInFuture(dayObj) || disableDatesObj.except && !checkDateInListIsInFiscalWeek(dayObj, disableDatesObj.except) || disableDatesObj.only && checkDateInListIsInFiscalWeek(dayObj, disableDatesObj.only)) {
      return true;
    }
  }
  return false;
};

export { capitalizeFirstLetter, checkBetweenFiscalWeek, checkDateInList, checkDateInListIsInFiscalWeek, checkFiscalWeekEndsInFuture, checkFutureDate, checkPastDate, checkSameDate, checkValidDateFormat, checkWeekdayDate, checkWeekendDate, dateFormat, displayFormat, formatValue, getData, headerFormat, isDayDisabledCheck, isWeeklyDisabledCheck, selectedDayCheck, selectedWeekCheck, toActiveMonth, toDateObj, toMonthArray, toWeekObj, useKeyPress };
